import React, { useEffect } from 'react';
import View from '../components/three/Scene3D/View';
import "swiper/css/bundle";
import "swiper/css";
import "swiper/css/effect-cards";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import Swal from 'sweetalert2';
import { gsap } from 'gsap'

function Yugi() {

    useEffect(() => {
        gsap.from('.yugi',
            {
                duration: 1,
                x: -1000
            })
            
        gsap.from('.kaiba',
            {
                duration: 1,
                x: 1000
            })
    }, []);



    const go = () => {
        Swal.fire({
            imageUrl: 'https://i.pinimg.com/564x/42/11/2d/42112d688b671c9ba477232a2db9e823.jpg',
            title: 'Serás redireccionado a una pagina para poder aprender a jugar',
            showCancelButton: true,
            confirmButtonText: 'Ir a  la pagina',
            cancelButtonText: 'Cancelar'
        }).then((result) => {

            if (result.isConfirmed) {
                window.open('https://img.yugioh-card.com/ygo_cms/ygo/all/uploads/SP-YS17-Beginner-Guide.pdf', '_blank');
            }
        })
    }

    return (
        <React.Fragment>
            <section className='first'>
                <div className='duo'>
                    <div className='yugi'></div>
                    <div className='kaiba'></div>
                </div>
                <h2>Cartas básicas</h2>
                <Swiper
                    effect={"cards"}
                    grabCursor={true}
                    modules={[EffectCards]}
                    className="mySwiper"
                >
                    <SwiperSlide></SwiperSlide>
                    <SwiperSlide></SwiperSlide>
                    <SwiperSlide></SwiperSlide>
                    <SwiperSlide></SwiperSlide>
                    <SwiperSlide></SwiperSlide>

                </Swiper>
            </section>
            <section className='last'>
                <div className="center-button">
                    <button className='learn' onClick={go}>¡Aprende a jugar YUGIOH!</button>
                </div>
                <View />
            </section>
        </React.Fragment>
    );


}
export default Yugi;